import { useState } from 'react';
import AddressBody from '../../../../features/Address/AddressBody';
import LibModal from '../../../../features/LibModal/LibModal';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import { EditIcon } from '../../../../utils/SVGIcon';
import { useAdminInfo } from '../AdminInfoProvider';
import { handleAddressSaveOpe } from './AddressOperation';
import AddressSameAsRadio from './AddressSameAsRadio';

// -- Address Edit Button
function AddressEditModal({ data, title }) {
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { setInfoReloadKey, customerDetailsData: customerData } = useAdminInfo();
    const { setMessage } = useTemplate();
    // -- Edit Address Modal
    const [showEditAddressModal, setShowEditAddressModal] = useState({
        show: false,
        data: {}
    });
    // -- initial form data
    const [formData, setFormData] = useState({
        addressType: title?.toString()?.toLowerCase(),
        userId: customerData?.id,
        ...data,
        Status: data.status
    });
    // -- Handle On Change to set form data
    const handleOnChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData({ ...formData, [name]: value });
        }
    };
    const handleSameAs = (e, type) => {
        const addressType = title?.toString()?.toLowerCase();
        setFormData({
            ...formData,
            ...customerData?.addresses?.[type],
            addressType
        });
    };
    // -- Save Edit Address
    const handleSaveEditAddress = (e) => {
        e.preventDefault();
        setLoading(true);
        handleAddressSaveOpe(formData, setIsError)
            .then(({ title: resTitle }) => {
                setMessage({ type: 'success', text: resTitle });
                setInfoReloadKey((d) => d + 1);
                setShowEditAddressModal({ show: false, data: {} });
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString() });
            });
    };
    FocusControl(isError, setIsError, formData);

    return (
        <>
            {/* Edit Address Button */}
            <button
                type="button"
                onClick={() =>
                    setShowEditAddressModal({ show: true, data }) +
                    setFormData({ ...formData, ...data })
                }
                className="w-7 h-7 bg-warning/10 hover:bg-warning text-warning hover:text-white-100  p-1 rounded-md transition-colors"
            >
                <EditIcon />
            </button>
            {/* Edit Address Modal */}
            {showEditAddressModal.show && (
                <LibModal
                    title="Edit Address"
                    setOpen={() => setShowEditAddressModal({ show: false, data: {} })}
                    className="sm:w-[570px]"
                >
                    <form onSubmit={handleSaveEditAddress}>
                        <div className="flex justify-start items-center gap-3 pb-5">
                            <AddressSameAsRadio
                                isShow={data?.addressType?.toString() !== 'administrative'}
                                type="administrative"
                                onClick={(e, type) => handleSameAs(e, type)}
                            />
                            <AddressSameAsRadio
                                isShow={data?.addressType?.toString() !== 'billing'}
                                type="billing"
                                onClick={(e, type) => handleSameAs(e, type)}
                            />
                            <AddressSameAsRadio
                                isShow={data?.addressType?.toString() !== 'technical'}
                                type="technical"
                                onClick={(e, type) => handleSameAs(e, type)}
                            />
                        </div>
                        <AddressBody formData={formData} onChange={handleOnChange} editMode />

                        <p className="text-xs text-error mt-3">All Fields Are Required!</p>
                        <div className="flex flex-row justify-end items-center gap-4 my-4">
                            <ButtonCancel
                                title="Cancel"
                                onClick={() => setShowEditAddressModal({ show: false, data: {} })}
                            />
                            <ButtonPrimary btnType="submit" title="Save" loading={loading} />
                        </div>
                    </form>
                </LibModal>
            )}
        </>
    );
}

export default AddressEditModal;
